module.exports = __webpack_public_path__ + "static/media/cryotherapy-primary.d1fcedee.jpg";